module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"balance":"Current balance","notFound":"Payments not found"},"et":{"balance":"Current balance","notFound":"Payments not found"},"ru":{"balance":"Current balance","notFound":"Payments not found"}}')
  delete Component.options._Ctor
}
